import React from "react";

export default function ToggleSwitch({
  checked,
  onChange,
  label,
  disabled = false,
  title,
}) {
  return (
    <button
      type="button"
      className={`cz-toggle${checked ? " is-on" : ""}${disabled ? " is-disabled" : ""}`}
      role="switch"
      aria-checked={checked}
      aria-label={label}
      aria-disabled={disabled || undefined}
      title={title}
      disabled={disabled}
      onClick={() => {
        if (!disabled) onChange(!checked);
      }}
    >
      <span className="cz-toggle-knob" />
    </button>
  );
}
